/**
 * Aquarius defect status in words and as a colour, shared by the Maintenance
 * tab's defect tables and the Driver tab's walkaround check details.
 */

const statusKey = (status: string | null | undefined, resolved?: boolean): string =>
  (String(status || '').trim() || (resolved ? 'Fixed' : 'Notfixed')).toLowerCase().replace(/[\s_-]/g, '');

/** "Not Fixed", "In Progress", "Fixed", "Next PMI"; anything else as Aquarius wrote it. */
export function formatDefectStatusLabel(status: string | null | undefined, resolved?: boolean): string {
  const raw = String(status || '').trim() || (resolved ? 'Fixed' : 'Notfixed');
  const labels: Record<string, string> = {
    notfixed: 'Not Fixed',
    inprogress: 'In Progress',
    fixed: 'Fixed',
    nextpmi: 'Next PMI',
  };
  return labels[statusKey(status, resolved)] || raw;
}

/** Not Fixed red, In Progress amber, Fixed green; undefined for any other status. */
export function defectStatusRowAccent(
  status: string | null | undefined,
  resolved?: boolean,
): 'red' | 'amber' | 'green' | undefined {
  const key = statusKey(status, resolved);
  if (key === 'notfixed') return 'red';
  if (key === 'inprogress') return 'amber';
  if (key === 'fixed') return 'green';
  return undefined;
}
